package horcrux.frontend.common.views.screens

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.views.org.LatestNews
import horcrux.frontend.common.views.components.containers.ViewWithLogo
import horcrux.frontend.common.views.navigation.ViewWithNavigationBar
import mui.material.Container
import mui.system.sx
import react.FC
import react.Props
import web.cssom.px

external interface LatestNewsScreenProps : Props {
    var globalAppState: GlobalAppState
}

val LatestNewsScreen = FC<LatestNewsScreenProps> { props ->
    ViewWithLogo {
        this.globalAppState = props.globalAppState
        ViewWithNavigationBar {
            this.route = Route.LATEST_NEWS
            this.globalAppState = props.globalAppState
            Container {
                this.sx {
                    this.marginTop = 50.px
                }
                LatestNews {}
            }
        }
    }
}
